import { GDPRConfig } from '@ecg-marktplaats/gdpr-consent-string';
import isExperimentEnabled from './isExperimentEnabled';
import Cookies from 'js-cookie';

const shouldResurfaceBannerForSourcepointExperiment = (): boolean => {
  const isNL = GDPRConfig.locale === 'nl-NL';
  let experimentKey: string, groups: Array<string>;
  /**
   * should resurface if sourcepoint experiment is enabled for control group
   * and consent cookies from old experiment is not cleared
   */
  if (isNL) {
    experimentKey = 'BNL19446';
    groups = ['A', 'C'];
  } else {
    experimentKey = 'BNL20533';
    groups = ['A'];
  }
  const visitedCookie: string = `${experimentKey}_VISITED`;

  return groups.some((group) => isExperimentEnabled(experimentKey, group)) && Cookies.get(visitedCookie) !== 'true';
};

export default shouldResurfaceBannerForSourcepointExperiment;
